import React from 'react'
import PropTypes from 'prop-types'
import assign from 'lodash/assign'
import { connect } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { getBoundActions } from '../../actions/index'
import { handleFocusNavigation } from '../Modal/utils'
import SubcategoryDescriptionFull from '../SubcategoryDescriptionFull/index'
import ModalShare from '../Share/index'
import ModalLinkShare from '../ModalLinkShare/index'
import ModalPortalFlag from '../ModalPortalFlag/index'
import ModalViewAll from '../ModalViewAll/index'
import ModalRemoveUser from '../ModalRemoveUser/index'
import DialogUpdateProfileImage from '../DialogUpdateProfileImage/index'
import ModalCartChangePlan from '../CartV2/ModalCartChangePlan/index'
import ForgotPassword from '../ForgotPassword/index'
import ModalFreeTrialExpired from '../ModalFreeTrialExpired/index'
import ModalLiveAccessEmailCapture from '../ModalLiveAccessEmailCapture/index'
import ModalUnsavedChanges from '../Portal/ModalUnsavedChanges/index'
import ModalConfigurableVideo from '../Daytona/Campaigns/WA-10/ModalConfigurableVideo'
import ModalHideContent from '../ModalHideContent/index'
import ModalPauseError from '../AccountPause/ModalPauseError/index'
import ModalPauseResume from '../AccountPause/ModalPauseResume/index'
import ModalCookieCompliance from '../ModalCookieCompliance/index'
import ModalConfirm from '../ModalConfirm/index'
import { ModalEndTrial } from '../ButtonEndTrial/ModalEndTrial'
import ShareToCircleModal from '../Community/Circles/ShareToCircle/ShareToCircleModal'
import MyAccountCancelModal from '../MyAccount/MyAccountCancelModal/index'
import MyAccountCancelAIModal from '../MyAccount/MyAccountCancelAIModal/index'
import MyAccountCancelWarningModal from '../MyAccount/MyAccountCancelWarningModal/index'
import MyAccountChangePlanModal from '../MyAccount/MyAccountChangePlanModal/index'
import MyAccountChangePlanPromoModal from '../MyAccount/MyAccountChangePlanPromoModal/index'
import MyAccountChildProfileChangePlanModal from '../MyAccount/MyAccountChildProfileChangePlanModal/index'
import MultiplePlaylistsShareModal from '../MultiplePlaylists/MultiplePlaylistsShareModal/index'
import MultiplePlaylistsShareTooltip from '../MultiplePlaylists/MultiplePlaylistsShareTooltip/index'
import MultiplePlaylistsAddModal from '../MultiplePlaylists/MultiplePlaylistsAddModal/index'
import MultiplePlaylistsAddModalGraphql from '../MultiplePlaylists/MultiplePlaylistsAddModal/MultiplePlaylistsAddModalGraphql/index'
import MultiplePlaylistsDeleteModal from '../MultiplePlaylists/MultiplePlaylistsDeleteModal/index'
import MultiplePlaylistsRenameModal from '../MultiplePlaylists/MultiplePlaylistsRenameModal/index'
import MyLibraryPlaylistDeleteModal from '../MyLibraryPage/MyLibraryPlaylistDeleteModal'
import MyLibraryPlaylistRenameModal from '../MyLibraryPage/MyLibraryPlaylistRenameModal'
import ModalGiftPeriodNotification from '../ModalGiftPeriodNotification/ModalGiftPeriodNotification'
import ModalGiftConfirm from '../Gift/ModalGiftConfirm/index'
import ModalGiftCreateAccount from '../Gift/ModalGiftCreateAccount/index'
import AnnouncementModal from '../Announcement/AnnouncementModal'
import { OneWatchCohortModalView } from '../OneWatchCohortModal/index'
import ModalPlanAccess from '../ModalPlanAccess/index'
import NotificationsVideoPromotionModal from '../NotificationsVideoPromotion/NotificationsVideoPromotionModal'
import { GiftPlanSelect } from '../Gift/GiftPlanSelect/index'
import ModalCartAbandon from '../CartV2/ModalCartAbandon/ModalCartAbandon'
import ModalCartAbandonV2 from '../CartV2/ModalCartAbandonV2/ModalCartAbandonV2'
import ModalPaymentFailed from '../CartV2/ModalPaymentFailed/index'
import CartSinglePageUpdateEmail from '../CartSinglePage/CartSinglePageUpdateEmail/index'
import CommentThreadReportModal from '../CommentThreadActions/CommentThreadReportModal'
import VibeQuizModal from '../Community/Identity/shared/VibeQuizModal/index'
import HistoryContext from '../Router/HistoryContext'
import Modal from '../Modal/index'
import Login from '../Login/index'
import LoginWithCodeModal from '../Login/LoginWithCode'
import IconV2, { ICON_TYPES } from '../Icon.v2/index'
import Button, { TYPES } from '../Button/index'
import { get as getConfig } from '../../config/index'

import {
  TYPE_MY_ACCOUNT_CHANGE_PLAN_CONFIRM,
  TYPE_MY_ACCOUNT_CHANGE_PLAN_PROMO,
  TYPE_MY_ACCOUNT_CHILD_PROFILE_CHANGE_PLAN,
  DIALOG_CLOSE_BUTTON_COLOR_WHITE,
  TYPE_LIVE_ACCESS_EMAIL_CAPTURE,
  TYPE_MULTIPLE_PROFILES_RM_USER,
  TYPE_SUBCATEGORY_DESCRIPTION,
  TYPE_USER_PLAYLIST_ADD_REMOVE,
  TYPE_USER_PLAYLIST_SHARE,
  TYPE_USER_PLAYLIST_TOOLTIP,
  TYPE_USER_PLAYLIST_DELETE,
  TYPE_USER_PLAYLIST_RENAME,
  TYPE_UPDATE_PROFILE_IMAGE,
  TYPE_GIFT_CREATE_ACCOUNT,
  TYPE_FREE_TRIAL_EXPIRED,
  TYPE_USER_PLAYLIST_ADD,
  TYPE_SELECT_GIFT_PLAN,
  TYPE_CART_CHANGE_PLAN,
  TYPE_FORGOT_PASSWORD,
  TYPE_SHARE_V2_SHARE,
  TYPE_DAYTONA_WA_10,
  TYPE_GIFT_CONFIRM,
  TYPE_ROW_VIEW_ALL,
  TYPE_HIDE_CONTENT,
  TYPE_CART_ABANDON,
  TYPE_PAUSE_RESUME,
  TYPE_PAUSE_ERROR,
  TYPE_PORTAL_EXIT,
  TYPE_PORTAL_FLAG,
  TYPE_LINK_SHARE,
  TYPE_CONFIRM,
  TYPE_END_TRIAL,
  TYPE_LOGIN,
  TYPE_LOGIN_WITH_CODE,
  getProps,
  TYPE_GIFT_PERIOD_NOTIFICATION,
  TYPE_MY_ACCOUNT_CANCEL_MEMBERSHIP,
  TYPE_MY_ACCOUNT_CANCEL_AI,
  TYPE_MY_ACCOUNT_CANCEL_WARNING,
  TYPE_COOKIE_COMPLIANCE,
  TYPE_ANNOUNCEMENT_MODAL,
  TYPE_ONE_WATCH_COHORT_MODAL,
  TYPE_MODAL_PLAN_ACCESS,
  TYPE_NOTIFICATION_VIDEO_PROMOTION,
  TYPE_CHECKOUT_UPDATE_EMAIL,
  TYPE_COMMENT_REPORT,
  TYPE_VIBE_QUIZ,
  TYPE_CIRCLES_SHARE,
  TYPE_PAYMENT_FAILED,
} from '../../services/dialog/index'

function warnFocus () {
  if (process.env.BROWSER && window.console) {
    window.console.warn(`
      Modal dialog warning :: it is advised to provide an onReturnFocus handler to Modal for accessibility use.
      Provide a no-operation (noop) handler if you want no return functionality.
    `)
  }
}

function stopPropagation (e) {
  e.stopPropagation()
}

function getClassName (visible, customClass) {
  const className = ['dialog', 'dialog--visible']
  if (customClass) className.push(customClass)
  return className.join(' ')
}

function iconClass (color) {
  const cls = ['icon--overlay-close', 'dialog__close-icon']
  if (color === DIALOG_CLOSE_BUTTON_COLOR_WHITE) cls.push('dialog__close-icon--white')
  return cls.join(' ')
}

function renderChild (componentName, props) {
  const { dialog } = props
  const customMessage = dialog.getIn(['options', 'customMessage'])
  const checkoutEmail = dialog.getIn(['options', 'checkoutEmail'])
  const config = getConfig()

  switch (componentName) {
    case TYPE_LOGIN:
      return <Login loginDialogMessage={customMessage} checkoutEmail={checkoutEmail} />
    case TYPE_LOGIN_WITH_CODE:
      return <LoginWithCodeModal />
    case TYPE_SHARE_V2_SHARE:
      return <ModalShare {...props} />
    case TYPE_DAYTONA_WA_10:
      return <ModalConfigurableVideo {...props} />
    case TYPE_LINK_SHARE:
      return <ModalLinkShare {...props} />
    case TYPE_MULTIPLE_PROFILES_RM_USER:
      return <ModalRemoveUser {...props} />
    case TYPE_LIVE_ACCESS_EMAIL_CAPTURE:
      return <ModalLiveAccessEmailCapture {...props} />
    case TYPE_FREE_TRIAL_EXPIRED:
      return <ModalFreeTrialExpired />
    case TYPE_PORTAL_FLAG:
      return <ModalPortalFlag {...props} />
    case TYPE_PORTAL_EXIT:
      return <ModalUnsavedChanges {...props} />
    case TYPE_ROW_VIEW_ALL:
      return <ModalViewAll {...props} />
    case TYPE_CART_CHANGE_PLAN:
      return <ModalCartChangePlan {...props} />
    case TYPE_UPDATE_PROFILE_IMAGE:
      return <DialogUpdateProfileImage />
    case TYPE_SUBCATEGORY_DESCRIPTION:
      return <SubcategoryDescriptionFull />
    case TYPE_FORGOT_PASSWORD:
      return <ForgotPassword {...props} />
    case TYPE_HIDE_CONTENT:
      return <ModalHideContent {...props} />
    case TYPE_PAUSE_ERROR:
      return <ModalPauseError {...props} />
    case TYPE_PAUSE_RESUME:
      return <ModalPauseResume {...props} />
    case TYPE_CONFIRM:
      return <ModalConfirm {...props} />
    case TYPE_END_TRIAL:
      return <ModalEndTrial {...props} />
    case TYPE_MY_ACCOUNT_CHANGE_PLAN_CONFIRM:
      return <MyAccountChangePlanModal {...props} />
    case TYPE_MY_ACCOUNT_CHANGE_PLAN_PROMO:
      return <MyAccountChangePlanPromoModal {...props} />
    case TYPE_MY_ACCOUNT_CANCEL_MEMBERSHIP:
      return <MyAccountCancelModal {...props} />
    case TYPE_MY_ACCOUNT_CANCEL_AI:
      return <MyAccountCancelAIModal {...props} />
    case TYPE_MY_ACCOUNT_CANCEL_WARNING:
      return <MyAccountCancelWarningModal {...props} />
    case TYPE_MY_ACCOUNT_CHILD_PROFILE_CHANGE_PLAN:
      return <MyAccountChildProfileChangePlanModal {...props} />
    case TYPE_USER_PLAYLIST_ADD:
      return <MultiplePlaylistsAddModal {...props} />
    case TYPE_USER_PLAYLIST_SHARE:
      return <MultiplePlaylistsShareModal {...props} />
    case TYPE_USER_PLAYLIST_TOOLTIP:
      return <MultiplePlaylistsShareTooltip {...props} />
    case TYPE_USER_PLAYLIST_DELETE:
      return config.features.myLibraryPageGraphQL
        ? <MyLibraryPlaylistDeleteModal {...props} />
        : <MultiplePlaylistsDeleteModal {...props} />
    case TYPE_USER_PLAYLIST_RENAME:
      return config.features.myLibraryPageGraphQL
        ? <MyLibraryPlaylistRenameModal {...props} />
        : <MultiplePlaylistsRenameModal {...props} />
    case TYPE_USER_PLAYLIST_ADD_REMOVE:
      return <MultiplePlaylistsAddModalGraphql {...props} />
    case TYPE_SELECT_GIFT_PLAN:
      return <GiftPlanSelect {...props} />
    case TYPE_CART_ABANDON:
      return config.features.modalCartAbandonV2
        ? <ModalCartAbandonV2 {...props} />
        : <ModalCartAbandon {...props} />
    case TYPE_COOKIE_COMPLIANCE:
      return <ModalCookieCompliance {...props} />
    case TYPE_GIFT_CONFIRM:
      return <ModalGiftConfirm {...props} />
    case TYPE_GIFT_CREATE_ACCOUNT:
      return <ModalGiftCreateAccount {...props} />
    case TYPE_GIFT_PERIOD_NOTIFICATION:
      return <ModalGiftPeriodNotification {...props} />
    case TYPE_ANNOUNCEMENT_MODAL:
      return <AnnouncementModal {...props} />
    case TYPE_ONE_WATCH_COHORT_MODAL:
      return <OneWatchCohortModalView {...props} />
    case TYPE_MODAL_PLAN_ACCESS:
      return <ModalPlanAccess {...props} />
    case TYPE_NOTIFICATION_VIDEO_PROMOTION:
      return <NotificationsVideoPromotionModal {...props} />
    case TYPE_CHECKOUT_UPDATE_EMAIL:
      return <CartSinglePageUpdateEmail {...props} />
    case TYPE_COMMENT_REPORT:
      return <CommentThreadReportModal {...props} />
    case TYPE_CIRCLES_SHARE:
      // Unreachable unless dispatched from the gate-checked Circles trigger
      // (ShareToCircle) — inert for everyone outside the Circles beta.
      return <ShareToCircleModal {...props} />
    case TYPE_VIBE_QUIZ: {
      const dialogConfig = getConfig()
      return dialogConfig?.features?.communityProfile
        ? <VibeQuizModal {...props} />
        : null
    }
    case TYPE_PAYMENT_FAILED:
      return <ModalPaymentFailed {...props} />
    default:
      return null
  }
}

class Dialog extends React.Component {
  componentDidMount () {
    // Add focus trap event listener for legacy dialogs
    this.boundHandleKeyDown = this.handleKeyDown.bind(this)
    document.addEventListener('keydown', this.boundHandleKeyDown, true)
  }

  componentWillUnmount () {
    // Remove focus trap event listener
    if (this.boundHandleKeyDown) {
      document.removeEventListener('keydown', this.boundHandleKeyDown, true)
    }
  }

  handleKeyDown = (event) => {
    const { dialog } = this.props
    const asModal = dialog.get('asModal', false)

    // Only apply focus trapping to legacy dialogs (not modals)
    if (asModal) return

    const dialogElement = document.querySelector('.dialog-overlay')
    if (!dialogElement) return

    handleFocusNavigation(event, dialogElement)
  }

  onDismissOverlay = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const { props } = this
    const {
      dialog,
      dismissModal,
      modalFreeTrialExpiredDismissed,
    } = props
    const name = dialog.get('componentName')
    const closeOnClick = dialog.get('closeOnClick')

    if (name === TYPE_FREE_TRIAL_EXPIRED) {
      modalFreeTrialExpiredDismissed(true)
    }

    if (closeOnClick !== false) {
      dismissModal(true)
    }
  }

  onDismiss = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const { props } = this
    const {
      dialog,
      dismissModal,
      modalFreeTrialExpiredDismissed,
    } = props
    const name = dialog.get('componentName')
    const extProps = getProps(name)
    const { onDismiss } = extProps

    if (name === TYPE_FREE_TRIAL_EXPIRED) {
      modalFreeTrialExpiredDismissed(true)
    }

    if (onDismiss) onDismiss(e)
    dismissModal(name)
  }

  renderLegacyDialog (content, className = '') {
    const { props } = this
    const { dialog } = props
    const hideCloseButton = dialog.getIn(['options', 'hideCloseButton'], false)
    const customClass = dialog.getIn(['options', 'customClass'], className)
    const btnColor = dialog.getIn(['options', 'closeButtonColor'], null)

    return (
      <div className={'dialog-overlay'} onClick={this.onDismissOverlay}>
        {/* eslint-disable-next-line */}
        <section
          className={getClassName(true, customClass)}
          onClick={stopPropagation}
          aria-modal="true"
          role="dialog"
        >
          <div className="dialog__content">{content}</div>
          {hideCloseButton ? null : (
            <Button
              type={TYPES.LINK}
              onClick={this.onDismiss}
              className={iconClass(btnColor)}
            >
              <IconV2
                type={ICON_TYPES.CLOSE}
              />
            </Button>
          )}
        </section>
      </div>
    )
  }

  renderModal (content, extProps) {
    const {
      onReturnFocus = warnFocus,
      hideDismiss = false,
      className = '',
      title = '',
      hideOverflow = false,
      type = null,
    } = extProps
    return (
      <Modal
        visible
        title={title}
        className={className}
        hideDismiss={hideDismiss}
        onDismiss={this.onDismiss}
        onReturnFocus={onReturnFocus}
        hideOverflow={hideOverflow}
        type={type}
      >
        {content}
      </Modal>
    )
  }

  render () {
    const { props, context: history } = this
    const { dialog, location, dismissModal } = props
    const name = dialog.get('componentName', '')
    const asModal = dialog.get('asModal', false)

    if (name) {
      let className

      if (name === TYPE_CART_CHANGE_PLAN) {
        className = 'modal--modal-cart-change-plan'
      }

      if (name === TYPE_MY_ACCOUNT_CHANGE_PLAN_CONFIRM) {
        className = 'modal--my-account-change-plan'
      }

      if (name === TYPE_USER_PLAYLIST_ADD
        || name === TYPE_USER_PLAYLIST_ADD_REMOVE
        || name === TYPE_USER_PLAYLIST_DELETE
        || name === TYPE_USER_PLAYLIST_RENAME
        || name === TYPE_USER_PLAYLIST_SHARE) {
        className = 'modal--multiple-playlists'
      }

      if (name === TYPE_COMMENT_REPORT) {
        className = 'modal--comments'
      }

      if (name === TYPE_CIRCLES_SHARE) {
        className = 'modal--circles-share'
      }

      if (name === TYPE_USER_PLAYLIST_SHARE) {
        className += ' modal--share-playlist'
      }

      if (name === TYPE_CART_ABANDON) {
        className = 'modal--cart-abandon'
      }

      if (name === TYPE_SELECT_GIFT_PLAN) {
        className = 'modal--fullscreen'
      }

      if (name === TYPE_LOGIN) {
        className = 'modal--login'
      }

      if (name === TYPE_COOKIE_COMPLIANCE) {
        className = 'modal--cookie-compliance'
      }

      if (name === TYPE_CHECKOUT_UPDATE_EMAIL) {
        className = 'modal--checkout-update-email'
      }

      if (name === TYPE_MY_ACCOUNT_CHANGE_PLAN_PROMO) {
        className = 'modal--my-account-change-plan-promo'
      }

      if (name === TYPE_MODAL_PLAN_ACCESS) {
        className = 'modal--plan-access'
      }

      if (name === TYPE_PAYMENT_FAILED) {
        className = 'modal--payment-failed'
      }

      if (name === TYPE_ONE_WATCH_COHORT_MODAL) {
        className = 'modal--one-watch-cohort'
      }

      const extProps = assign({}, getProps(name), {
        location, history, dismissModal, className, dialog,
      })
      const content = renderChild(name, extProps)
      if (content) {
        // VibeQuizModal manages its own overlay — render without wrapper
        if (name === TYPE_VIBE_QUIZ) {
          return content
        }
        return asModal
          ? this.renderModal(content, extProps) // NEW HOTNESS
          : this.renderLegacyDialog(content, className) // LEGACY DIALOG - DEPRICATED
      }
    }
    return null
  }
}

Dialog.propTypes = {
  dialog: ImmutablePropTypes.map.isRequired,
  dismissModal: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
}

Dialog.contextType = HistoryContext

export default connect(
  (state) => ({
    optimizely: state.optimizely,
    dialog: state.dialog,
  }),
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      dismissModal: actions.dialog.dismissModal,
      modalFreeTrialExpiredDismissed: actions.user.modalFreeTrialExpiredDismissed,
    }
  },
)(Dialog)
